export const BUILDING_NUMBER_MIN_LENGTH = 1;
export const BUILDING_NUMBER_MAX_LENGTH = 50;
export const BUILDING_NOTES_MIN_LENGTH = 1;
export const BUILDING_NOTES_MAX_LENGTH = 5000;
